export const REDUX_NAMESPACE = 'CONTENT';

export const FILL_COLOR_UPDATE_GROUP = Symbol();
export const BACKGROUND_COLOR_UPDATE_GROUP = Symbol();
